<template>
  <r-panel :disabled="disabled" :title="title">
    <div style="width: 100%">
      <v-row dense>
        <v-divider/>
      </v-row>
      <v-row dense class="mt-2">
        <v-autocomplete
            v-model="value"
            :items="values"
            item-text="key"
            item-value="key"
            label="Select Currency"
            chips
            small-chips
            deletable-chips
            return-object
            multiple
            hint="The currency will be reset when the event starts."
            persistent-hint
        ></v-autocomplete>
      </v-row>
    </div>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

export default {
  name: "r-smart-offer-reset-currency",
  components: {RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def(""),
    items: VueTypes.arrayOf(CurrencyKindModel)
  },
  computed: {
    value: {
      get: function () {
          return this.items;
      },
      set: function (value) {
          this.$emit("update:items", value);
      }
    },
    values() {
      return RedactorUtils.getCurrencyKinds();
    }
  }
}
</script>